import { TYPES } from "./default_debug.type";
import { onSnapshot, query, where, orderBy } from "firebase/firestore";
//func
import { getRefs } from "../ref";
import { getApiFunctions } from "store/bailiff/api";

// ========= firebase function =========//

//snap all provider
const allDefaultDebugSub = [];
export const snapDefaultDebug = (callback) => (dispatch) => {
  setDefaultDebugAllSuccess(dispatch, null);
  const cRef = getRefs().debug;
  const c0 = where("collection", "==", "job");
  const c1 = where("database", "==", "bailiff");
  const c2 = orderBy("createAt", "desc");
  const qRef = query(cRef, c0, c1, c2);
  const unsub = onSnapshot(qRef, (snapshot) => {
    if (snapshot) {
      const data = snapshot.docs.map((doc) => doc.data());
      setDefaultDebugAllSuccess(dispatch, data);
      if (callback) {
        callback();
      }
    }
  });
  allDefaultDebugSub.push(unsub);
};

export const unSnapDefaultDebug = () => (dispatch) => {
  allDefaultDebugSub.forEach((subscriber) => {
    subscriber();
  });
  allDefaultDebugSub.length = 0;
};
// ========= cloud function =========//

export const cloudOperatorAddJobDebug =
  ({ id }, callback) =>
  (dispatch) => {
    const functions = getApiFunctions().operator.debugJob;
    const options = { id };
    functions(options)
      .then(() => {
        callback && callback({ status: 200 });
      })
      .catch((err) => {
        console.log({ err });
        callback &&
          callback({ status: 500, data: err?.message || "Please try again!" });
      });
  };

// ========= local function =========//
export const setDefaultDebugAll = (data, callback) => (dispatch) => {
  setDefaultDebugAllSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDefaultDebugOpenAdd = (data, callback) => (dispatch) => {
  setDefaultDebugOpenAddSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDefaultDebugOpenEdit = (data, callback) => (dispatch) => {
  setDefaultDebugOpenEditSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDefaultDebugSelected = (data, callback) => (dispatch) => {
  setDefaultDebugSelectedSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDefaultDebugSearch = (data, callback) => (dispatch) => {
  setDefaultDebugSearchSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

// ========= dispatch =========//

const setDefaultDebugAllSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DEFAULT_DEBUG_ALL,
    payload: data,
  });
};

const setDefaultDebugOpenAddSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DEFAULT_DEBUG_OPEN_ADD,
    payload: data,
  });
};

const setDefaultDebugOpenEditSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DEFAULT_DEBUG_OPEN_EDIT,
    payload: data,
  });
};

const setDefaultDebugSelectedSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DEFAULT_DEBUG_SELECTED,
    payload: data,
  });
};

const setDefaultDebugSearchSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DEFAULT_DEBUG_SEARCH,
    payload: data,
  });
};
